// Campus photo for /colleges/university-of-pennsylvania: CC BY-SA 2.0, by Michel Alexandre Salim, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ACollege_Hall%2C_University_of_Pennsylvania.jpg), checked 2026-09-30 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-pennsylvania/; credited under the photo.
const photo = {
    "slug": "university-of-pennsylvania",
    "alt": "College Hall at the University of Pennsylvania in Philadelphia",
    "src": "/colleges/university-of-pennsylvania/campus-1600.webp",
    "srcSmall": "/colleges/university-of-pennsylvania/campus-800.webp",
    "srcMid": "/colleges/university-of-pennsylvania/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-pennsylvania/og.jpg",
    "title": "College Hall, University of Pennsylvania",
    "author": "Michel Alexandre Salim",
    "license": "CC BY-SA 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ACollege_Hall%2C_University_of_Pennsylvania.jpg",
    "read": "2026-09-30"
};

export default photo;
